module.exports = __webpack_public_path__ + "static/media/Stellar Vox King Headboard - 180 cm_Charcoal.477d810b.png";